module.exports = __webpack_public_path__ + "img/banner8.0d497a2d.svg";